export const BALANCES_V2_BLOTTER_PREFIX = 'principal/balances_v2';
